/**
 * Build metadata for debugging and version tracking
 * Injected at build time by Vite
 */

export interface BuildInfo {
  version: string;
  commitHash: string;
  buildTime: string;
  shortCommit: string;
}

export const buildInfo: BuildInfo = {
  version: __APP_VERSION__,
  commitHash: __GIT_COMMIT__,
  buildTime: __BUILD_TIME__,
  shortCommit: __GIT_COMMIT__.substring(0, 7),
};

// Expose globally for console debugging
if (typeof window !== 'undefined') {
  (window as any).__BUILD_INFO__ = buildInfo;
}

// Log in development
if (import.meta.env.DEV) {
  console.log('🏗️ Build Info:', buildInfo);
}
